import { useCallback, useEffect, useRef, useState } from "react";
import { doPostMessage } from "../utils/rn";
import { Renderer } from "vexflow4";
import SingleStaveHandler from "../common/singleStaveHandler";
import 'weui';
import 'react-weui-ts/build/dist/react-weui.css';
import QuestionsTopNavBar from "../components/QuestionsTopNavBar";
import TrashButton from "../components/buttons/QuestionTrashButton";
import { majorTrans, noteAccInMajor, questionGenerate } from "../utils/questionUtils";
import { distance, height, Key, Note, transpose } from "tonal";
import { SpinLoading } from 'antd-mobile'
import { arrEqualIgnoreOrder } from "../utils/helpers";

const pt = console.log

const test = () => {
    // console.log(distance('G#', 'D#'));
    // console.log(distance('D3', 'D#4'));
    // console.log(simplifyRelation('D3', 'D#4'));
    // console.log([1,2,3,4,5,6,7].map(Scale.degrees('E major')));
    // console.log(transpose('D#', '3M'));
    // console.log(transpose('D#', '3M'));
    // console.log(mapToCMajor('F#', 'E'));
    // console.log(majorT('Fb4', 'E', false));
    // console.log(transpose('Ab4', '5d'))
    // pt(distance('E#4', 'D###4'));
    // pt(majorTrans('D##4', 'C#'));
    // pt(transpose('E4','-2d'))
    // pt(noteAccInMajor('E4', 'C#'));
    // pt(Key.majorKey('C#').scale);
}

test();

export const staveFormat = (conf: any) => {
    if (!conf.baseNote || !Array.isArray(conf.baseNote) || conf.baseNote.length === 0) {
        return {
            keys: ['C/4'],
            duration: "1",
            accidentals: []
        }
    }

    const baseNote = conf.baseNote.filter((v: any) => v && typeof v === 'string').map((v: string) => v.replace('/', ''));
    const accidentals: any[] = [];
    baseNote.forEach((v: string, i: number) => {
        try {
            const note = Note.get(v);
            if (note && note.acc) {
                accidentals.push({ index: i, modifier: note.acc });
            }
        } catch (e) {
            // 忽略无效音符
        }
    })
    const keys = [...conf.baseNote]
    return {
        keys,
        duration: "1",
        accidentals
    }
}

const scale = 0.9;

const QuestionStave = () => {
    const [handler, setHandler] = useState<SingleStaveHandler | null>(null);
    const [staveJson, setStaveJson] = useState<string>('');
    const [dataJson, setDataJson] = useState<any>(null);
    const question_type = localStorage.getItem('question_type') || 'YinCheng';
    const isLianEr = ['LianErYinCheng', 'LianErHeXian', 'LianErDanYin'].indexOf(question_type) !== -1;
    const [show, setShow] = useState(false);
    const [defaultNote, setDefaultNote] = useState<string>('')
    const [windowDimensions, setWindowDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const [webSize, setWebsize] = useState({ width: 0, height: 0 });
    const [staveTopSpace, setStaveTopSpace] = useState(0);

    const staveRef = useRef<HTMLCanvasElement>(null);

    const createQuestion = () => {
        const questionType = localStorage.getItem('question_type') ?? '';
        const dataJson: any = questionGenerate(questionType);

        if (handler && handler instanceof SingleStaveHandler) {
            handler.stop();
        }

        try {
            setShow(false);
            setDataJson(dataJson);
            initStave(dataJson);
            doPostMessage(dataJson, 'create_question');
        } catch (e: any) {
            const stackTrace = e.stack;

            // 将堆栈信息转换为文本（实际上它默认就是一个字符串）
            const stackTraceText = stackTrace.toString();

            // 打印堆栈信息文本
            // alert(stackTraceText);
            // alert(e.message);

            doPostMessage('', 'create_question_failed');
            doPostMessage({
                error: e.message,
                error_stack: stackTraceText,
            }, 'web_error');
        } finally {
            setShow(true);
        }

        return dataJson;
    }

    const revertQuestion = () => {
        try {
            const jsonString = localStorage.getItem('question_config') ?? '';
            const dataJson: any = JSON.parse(jsonString);

            setDataJson(dataJson);
            initStave(dataJson);

            return dataJson;
        } catch (e) {

        }
    }

    useEffect(() => {
        doPostMessage('', 'loaded');

        resize();

        const viewportMeta = document.querySelector('meta[name="viewport"]');
        viewportMeta?.setAttribute("content", `width=device-width, initial-scale=${scale}, user-scalable=no`);
    }, []);

    const initStave = (data: any) => {
        ['YinCheng', 'HeXian'].indexOf(question_type) !== -1 ? localStorage.setItem('yincheng_tone', data.key) : localStorage.removeItem('yincheng_tone');
        const render = new Renderer(staveRef.current ?? '', Renderer.Backends.CANVAS);

        // 设置渲染器的尺寸
        render.resize(windowDimensions.width, windowDimensions.height / 4);

        const handler = new SingleStaveHandler(render);
        handler.stop();
        handler.setCurrentNote(null);

        const defaultNoteCopy = data.baseNote && data.baseNote.length > 0 ? [...data.baseNote][0] : ''
        setDefaultNote(defaultNoteCopy);
        if (!isLianEr) {
            const staveFmt = staveFormat(data);
            handler.setStaveNotes([staveFmt]);
            doPostMessage(staveFmt, 'render_stave')
        } else {
            handler.setStaveNotes([]);
        }
        handler.duration = 'w';
        handler.init();
        handler.startListenTouchEvent(staveRef.current);
        handler.setRedrawCallback((data: string) => {
            setStaveJson(data);
        })
        setHandler(handler);
        setShow(true);
    };

    useEffect(() => {
        if (staveJson) {
            try {
                let isCorrect = false;
                const staveJsonObj = JSON.parse(staveJson);
                // 判断答案是否正确
                if (question_type === 'YinCheng') {
                    const userInputAnswer = staveJsonObj[0].notes[0].keys.slice(-1)[0];
                    const userInputAcc = staveJsonObj[0].notes[0].accidentals?.slice(-1)[0]?.modifier || '';
                    const configAnswer = dataJson.answer;
                    isCorrect = userInputAnswer.replace('/', `${userInputAcc}/`) === configAnswer;
                }
                if (question_type === 'HeXian') {
                    const userInputAnswer = staveJsonObj[0].notes[0].keys;
                    const userInputAccidentals = staveJsonObj[0].notes[0].accidentals;
                    if (userInputAnswer.length === 3) {
                        const t1 = userInputAnswer[1];
                        const t2 = userInputAnswer[2];
                        const t1Acc = userInputAccidentals.find((v: any) => v.index === 1)?.modifier || '';
                        const t2Acc = userInputAccidentals.find((v: any) => v.index === 2)?.modifier || '';
                        isCorrect = dataJson.answer.every((val: string) =>
                            (val === t1.replace('/', `${t1Acc}/`)) || (val === t2.replace('/', `${t2Acc}/`)))
                    }
                    if (userInputAnswer.length === 4) {
                        const t1 = userInputAnswer[1];
                        const t2 = userInputAnswer[2];
                        const t3 = userInputAnswer[3];
                        const t1Acc = userInputAccidentals.find((v: any) => v.index === 1)?.modifier || '';
                        const t2Acc = userInputAccidentals.find((v: any) => v.index === 2)?.modifier || '';
                        const t3Acc = userInputAccidentals.find((v: any) => v.index === 3)?.modifier || '';
                        isCorrect = dataJson.answer.every((val: string) =>
                            (val === t1.replace('/', `${t1Acc}/`)) || (val === t2.replace('/', `${t2Acc}/`)) || (val === t3.replace('/', `${t3Acc}/`)))
                    }
                }
                if (question_type === 'YinJie') {
                    // 整理用户输入的答案
                    const notes = staveJsonObj[0].notes;
                    if (notes.length === 6 || notes.length === 8) {
                        const userInputAnswers = notes.slice(1).map((note: any) => {
                            let acc = ''
                            if (note.accidentals.length !== 0) {
                                acc = note.accidentals[0].modifier;
                            }
                            return note.keys[0].replace('/', `${acc}/`);
                        });
                        const answer = dataJson.answer;
                        isCorrect = answer.length === userInputAnswers.length && answer.every((value: string, index: number) => value[0] === userInputAnswers[index]);
                    }
                }
                if (question_type.includes('LianEr')) {
                    // 练耳题
                    const notes = staveJsonObj[0].notes[0];
                    const answer = dataJson.answer;
                    const userInputAnswers: string[] = [];
                    if (notes.keys.length === answer.length) {
                        // 用户输入和答案长度一致，判断音符是否正确
                        notes.keys.forEach((note: string, index: number) => {
                            let acc = '';
                            notes.accidentals.forEach((item: any) => {
                                if (index === item.index) {
                                    acc = item.modifier
                                }
                            })
                            const noteObj = Note.get(note.replace('/', ''));
                            userInputAnswers.push(`${noteObj.letter}${acc}/${noteObj.oct}`);
                        });
                    }
                    isCorrect = arrEqualIgnoreOrder(userInputAnswers, answer);
                }
                doPostMessage({ stave: staveJson, isCorrect }, 'answer');
            } catch (e) {
            }
        }
    }, [staveJson]);

    const resize = () => {
        const marginTop = parseInt(localStorage.getItem('stave_top_space') ?? '0');
        const width = localStorage.getItem('web_width') ?? '400';
        const height = localStorage.getItem('web_height') ?? '200';
        handler?.resize(parseInt(width) / scale);
        handler?.redraw();

        setWebsize({ width: parseInt(width), height: parseInt(height) });
        setStaveTopSpace(marginTop)
    };

    return (
        <>
            <div id="generateQuestion" onClick={() => createQuestion()} />
            <div id="revertQuestion" onClick={() => revertQuestion()} />
            <div id="resize" onClick={() => resize()} />
            <QuestionsTopNavBar handler={handler} isLianEr={isLianEr} dataJson={dataJson} />
            <div style={{ height: staveTopSpace, width: 1 }}></div>
            <div style={show ? {
                width: '100%',
                height: `${(webSize.height / scale) / 2}px`,
                maxWidth: '100vw',
                overflow: 'hidden'
            } : { visibility: 'hidden' }}>
                <canvas style={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '100vw'
                }} ref={staveRef} />
            </div>
            {
                !show &&
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '5rem' }}>
                    <SpinLoading style={{ '--size': '48px' }} />
                </div>
            }
            {
                handler && <TrashButton
                    cleanAll={() => {
                        handler.duration = 'w';
                        if (!question_type.includes('LianEr')) {
                            const staveFmt = staveFormat(dataJson);
                            handler.setStaveNotes([staveFmt]);
                        } else {
                            handler.setStaveNotes([]);
                        }
                        handler.init();
                    }}
                    downAction={() => handler.downAllKeys(defaultNote)}
                    upAction={() => handler.upAllKeys(defaultNote)}
                />
            }
        </>
    );
};

export default QuestionStave
